<template>
  <header v-if="visible" class="share-browse-header">
    <button type="button" class="share-browse-header__back" @click="goHub">
      <PmIcon name="Left" size="sm" aria-hidden="true" />
      <span>返回索引</span>
    </button>
    <span class="share-browse-header__title">{{ title }}</span>
  </header>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PmIcon from '../components/PmIcon.vue';

const route = useRoute();
const router = useRouter();

const visible = computed(() => {
  const p = route.path;
  if (p === '/completed-pages' || p.startsWith('/completed-pages/p/')) return false;
  if (p.startsWith('/business/page-layouts/p/')) return false;
  // 分享站内 App 小程序下钻伴生路由：勿显示「返回索引」顶栏
  if (p.startsWith('/design-test/')) return false;
  return true;
});

const title = computed(() => {
  const p = route.path;
  if (p.startsWith('/business')) return '业务组件';
  if (p.startsWith('/el-') || p.startsWith('/pm-') || p === '/foundation') return '基础组件';
  return '预览';
});

function goHub() {
  router.push('/completed-pages');
}
</script>

<style lang="scss" scoped>
@import '@styles/variables';

.share-browse-header {
  position: sticky;
  top: 0;
  z-index: 900;
  display: flex;
  align-items: center;
  gap: $spacing-16;
  height: 44px;
  padding: 0 16px;
  background: $color-greyscale-900;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.share-browse-header__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: none;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: $color-greyscale-200;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    color: $color-greyscale-00;
  }
}

.share-browse-header__title {
  font-size: 13px;
  color: $color-greyscale-400;
}
</style>
